module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "WOKTLogo.2376971f.png";